import { ANALYSIS_TYPE, ASSETS_TYPE, CHARGE_TYPE, PRODUCTION_COST_TYPE, SCHEDULE_TYPE, SOURCE_TYPE } from '@/component/evaluate/data/enum';
import { CardParam, Schedule } from '@/component/evaluate/data/interface';
import { cardParam, cardParam2, cardParam3, cardParam4, cardParam5, cardParam6 } from '@/component/evaluate/data/cardParam';

const Evaluate = {
    state: {
        schedule: {},
        routeName: '',
        theme: 'light',
        planList: [],
    },
    getters: {
        getCardParamBySchedule: (state: { schedule: CardParam[]; routeName: string }) => {
            switch (state.routeName) {
                case 'schedule':
                    Object.keys(SCHEDULE_TYPE).forEach((key: string) => {
                        if (Object.prototype.hasOwnProperty.call(state.schedule, key)) {
                            cardParam[SCHEDULE_TYPE[key]].value = state.schedule[key];
                        }
                    });
                    return cardParam;
                case 'source':
                    Object.keys(SOURCE_TYPE).forEach((key: string) => {
                        if (Object.prototype.hasOwnProperty.call(state.schedule, key)) {
                            cardParam2[SOURCE_TYPE[key]].value = state.schedule[key];
                        }
                    });
                    return cardParam2;
                case 'assets':
                    Object.keys(ASSETS_TYPE).forEach((key: string) => {
                        if (Object.prototype.hasOwnProperty.call(state.schedule, key)) {
                            cardParam3[ASSETS_TYPE[key]].value = state.schedule[key];
                        }
                    });
                    return cardParam3;
                case 'productionCost':
                    Object.keys(PRODUCTION_COST_TYPE).forEach((key: string) => {
                        if (Object.prototype.hasOwnProperty.call(state.schedule, key)) {
                            cardParam4[PRODUCTION_COST_TYPE[key]].value = state.schedule[key];
                        }
                    });
                    return cardParam4;
                case 'charge':
                    Object.keys(CHARGE_TYPE).forEach((key: string) => {
                        if (Object.prototype.hasOwnProperty.call(state.schedule, key)) {
                            cardParam5[CHARGE_TYPE[key]].value = state.schedule[key];
                        }
                    });
                    return cardParam5;
                default:
                    Object.keys(ANALYSIS_TYPE).forEach((key: string) => {
                        if (Object.prototype.hasOwnProperty.call(state.schedule, key)) {
                            cardParam6[ANALYSIS_TYPE[key]].value = state.schedule[key];
                        }
                    });
                    return cardParam6;
            }
        },

        getTheme: (state) => {
            return state.theme;
        },
        getPlanList: (state) => {
            return state.planList;
        },
    },
    mutations: {
        setSchedule: (state, data: Schedule) => {
            state.schedule = data;
        },
        setRoute: (state, data: string) => {
            state.routeName = data;
        },
        setTheme: (state, data: string) => {
            localStorage.setItem('theme', data);
            state.theme = data;
        },
        setPlanList: (state, payLoad) => {
            state.planList = payLoad;
        },
    },
    actions: {},
};
export default Evaluate;
